import { createContext, useContext } from "react";
import type {
  GetFlightAvailabilityTokenFlight,
  GetFlightAvailabilityTokenOutputData,
} from "../../types/codegen";

export interface SingleFlightSelectionContextValue {
  singleFlightDetails: SingleFightDetailsData;
  departureFlight: GetFlightAvailabilityTokenFlight | null;
  returnFlight: GetFlightAvailabilityTokenFlight | null;
  isAdditionalDataLoading: boolean;
}

export type SingleFightDetailsData =
  Partial<GetFlightAvailabilityTokenOutputData>;

export const SingleFlightSelectionContext =
  createContext<SingleFlightSelectionContextValue | null>(null);

export const useSingleFlightSelectionContext = () => {
  const context = useContext(SingleFlightSelectionContext);
  if (!context) {
    throw new Error(
      "useSingleFlightSelectionContext must be used within a SingleFlightDetailsProvider",
    );
  }
  return context;
};
